import request from '@/utils/request'
// 获取服务商列表
export function getList(params) {
  return request({
    url: '/account_management/service_providers',
    method: 'get',
    params
  })
}
// 创建服务商
export function addServiceProvider(data) {
  return request({
    url: '/account_management/service_providers',
    method: 'post',
    data
  })
}
// 修改服务商
export function modifyServiceProvider(id, params) {
  return request({
    url: `/account_management/service_providers/${id}`,
    method: 'put',
    params
  })
}

// 获取平台
export function accessplatform() {
  return request({
    url: '/platform',
    method: 'get'
  })
}
// 获取平台新
export function accessplatformnew() {
  return request({
    url: '/novel_management/platforms',
    method: 'get'
  })
}

// 获取平台账号
export function getPlatformAccount(id) {
  return request({
    url: `/platform/account?platform_id=${id}`,
    method: 'get'
  })
}

// 增加平台账号
export function addPlatformAccount(id, obj = {}, account_name = undefined) {
  return request({
    url: '/platform/account',
    method: 'post',
    data: {
      platform_id: id,
      data: obj,
      account_name
    }
  })
}

// 更新站点
export function myUpdateSite(id) {
  return request({
    url: '/platform/update_appid_list',
    method: 'post',
    data: {
      platform_id: id
    }
  })
}

// 禁启用
export function disableEnable(id, status) {
  return request({
    url: `/platform/account/${id}`,
    method: 'PUT',
    data: {
      status
    }
  })
}

// 修改数据
export function modifyData(id, data, account_name) {
  return request({
    url: `/platform/account/${id}`,
    method: 'PUT',
    data: {
      data,
      account_name
    }
  })
}

// 删除平台账号
export function deletePlatformAccount(id) {
  return request({
    url: `/platform/account/${id}`,
    method: 'DELETE'
  })
}

// 添加平台账号
export function addPlatform(name, struct) {
  return request({
    url: `/platform`,
    method: 'post',
    data: {
      name,
      struct
    }
  })
}

// 选择日期拉取订单数据
export function chose_date_pull_data(data = {}) {
  return request({
    url: `/report_form/predit/chose_date_pull_data`,
    method: 'post',
    data
  })
}

// 账号同步微播订单
export function synchronous(data) {
  return request({
    url: `/platform/account/synchronous_weibo_order`,
    method: 'post',
    data
  })
}
// 广告链接列表
export function advertisementlist(params) {
  return request({
    url: `/ad_management/ad_url`,
    method: 'get',
    params
  })
}
// 广告链接添加
export function advertisementlistadd(data) {
  return request({
    url: `/ad_management/ad_url`,
    method: 'post',
    data
  })
}
// 广告链接更新
export function modifyDatar(id, monitor_status, phone) {
  return request({
    url: `/ad_management/ad_url/${id}`,
    method: 'PUT',
    data: {
      monitor_status,
      phone
    }
  })
}

// 广告链接删除
export function deletemanag(id) {
  return request({
    url: `/ad_management/ad_url/${id}`,
    method: 'DELETE'
  })
}
// 商户收款码列表
export function payrlist(params) {
  return request({
    url: `/wechat/pay_code`,
    method: 'get',
    params
  })
}
// 商户付款码添加
export function wechatpay(data) {
  return request({
    url: `/wechat/pay_code`,
    method: 'post',
    data
  })
}
// 商户付款码删除
export function deletepay(id) {
  return request({
    url: `/wechat/pay_code/${id}`,
    method: 'DELETE'
  })
}
// 商户付款码更新
export function wechatunable(id, name, principal, phone, qrcode_url) {
  return request({
    url: `/wechat/pay_code/${id}`,
    method: 'PUT',
    data: {
      name,
      principal,
      phone,
      qrcode_url
    }
  })
}
// 测试微信账号添加
export function testwechatadd(data) {
  return request({
    url: `/wechat/account_test`,
    method: 'post',
    data
  })
}
// 测试微信账号列表
export function accounttestlist(params) {
  return request({
    url: `/wechat/account_test`,
    method: 'get',
    params
  })
}
// 测试微信账号更新
export function testwechatupdata(id, account_name, login_pwd, pay_pwd) {
  return request({
    url: `/wechat/account_test/${id}`,
    method: 'PUT',
    data: {
      account_name,
      login_pwd,
      pay_pwd
    }
  })
}

// 测试微信账号删除
export function deletetestwechat(id) {
  return request({
    url: `/wechat/account_test/${id}`,
    method: 'DELETE'
  })
}
// 支付记录
export function payrecord(id, params) {
  return request({
    url: `/wechat/pay_code/record/${id}`,
    method: 'get',
    params
  })
}
// 删除平台
export function deleteproform(data) {
  return request({
    url: `/platform/account/batch_delete`,
    method: 'post',
    data
  })
}
// 定时复制列表
export function timinglist(params) {
  return request({
    url: `/ad_copy/ad_cron_list`,
    method: 'get',
    params
  })
}
// 设置定时开关
export function modwifyDatar(id, status) {
  return request({
    url: `/ad_copy/ad_cron_set_status`,
    method: 'PUT',
    data: {
      id,
      status
    }
  })
}
// 企微公司添加
export function wechatcompany(data) {
  return request({
    url: `/wechat/wechat_company`,
    method: 'post',
    data
  })
}
// 企微公司列表
export function wechatcompanying(params) {
  return request({
    url: `/wechat/wechat_company`,
    method: 'get',
    params
  })
}
// 企微公司更新
export function wechatcomupdata(id, company_name, clock_in) {
  return request({
    url: `/wechat/wechat_company/${id}`,
    method: 'PUT',
    data: {
      company_name,
      clock_in
    }
  })
}
// 企微公司删除
export function deletetestwechatr(id) {
  return request({
    url: `/wechat/wechat_company/${id}`,
    method: 'DELETE'
  })
}
// 企微账户添加
export function wechatcompanyaccount(data) {
  return request({
    url: `/wechat/wechat_company_account`,
    method: 'post',
    data
  })
}
// 企微账户列表
export function wechatcompanyingaccount(params) {
  return request({
    url: `/wechat/wechat_company_account`,
    method: 'get',
    params
  })
}
// 企微账户更新
export function wechatcomupdataaccount(id, account, phone) {
  return request({
    url: `/wechat/wechat_company_account/${id}`,
    method: 'PUT',
    data: {
      account,
      phone
    }
  })
}
// 企微账户删除
export function deletetestwechatraccount(id) {
  return request({
    url: `/wechat/wechat_company_account/${id}`,
    method: 'DELETE'
  })
}
// 企微群组添加
export function wechatgroupaccount(data) {
  return request({
    url: `/wechat/wechat_group`,
    method: 'post',
    data
  })
}
// 企微群组列表
export function wechatgroupccountlist(params) {
  return request({
    url: `/wechat/wechat_group`,
    method: 'get',
    params
  })
}
// 企微群组更新
export function wechatcomupwechatgroup(id, account_id, company_id, group_name, message, timeHi, include_status) {
  return request({
    url: `/wechat/wechat_group/${id}`,
    method: 'PUT',
    data: {
      account_id,
      company_id,
      group_name,
      message,
      timeHi,
      include_status
    }
  })
}
// 企微群组删除
export function deletegroupccount(id) {
  return request({
    url: `/wechat/wechat_group/${id}`,
    method: 'DELETE'
  })
}

export function payrecordr(id, params) {
  return request({
    url: `/wechat/wechat_group/record/${id}`,
    method: 'get',
    params
  })
}

// 获取行为源
export function behaviorsource(data) {
  return request({
    url: `/book_report/xingwei`,
    method: 'post',
    data
  })
}
// 提交行为源
export function sawrbehaviorsource(data) {
  return request({
    url: `/ad_management/post_pack_configs`,
    method: 'post',
    data
  })
}
// 获取行为源详情
export function behaviorsourcedetail(id) {
  return request({
    url: `/ad_management/post_pack_configs/${id}`,
    method: 'get'
  })
}

// 获取企微公司列表
export function getMicroEnterprise(params = {}) {
  return request({
    url: `/workWechat/corp/index`,
    method: 'get',
    params
  })
}

// 新建企微公司
export function newEnterpriseAndMicro(data = {}) {
  return request({
    url: `/workWechat/corp/store`,
    method: 'post',
    data
  })
}

// 更新企微公司
// export function wechatcomupdataaccountr(id, corpId, corpName) {
//   return request({
//     url: `/workWechat/corp/update`,
//     method: 'post',
//     data: {
//       corpId,
//       corpName
//     }
//   })
// }

export function wechatcomupdataaccountr(data) {
  return request({
    url: `/workWechat/corp/update`,
    method: 'post',
    data
  })
}

// 删除企微公司
export function delteMicro(id) {
  return request({
    url: `/workWechat/corp/destroy`,
    method: 'post',
    data: {
      corpKeyId: id
    }
  })
}
// 企业筛选列表
export function enterpriseMicro(params) {
  return request({
    url: `/workWechat/corp/list`,
    method: 'get',
    params
  })
}

// 更新部门成员
export function updateDepartment(data = {}) {
  return request({
    url: `/workWechat/corp/updateDepartment`,
    method: 'post',
    data
  })
}
// 获取预定头像
export function getavatarList() {
  return request({
    url: `/workWechat/kf/avatarList`,
    method: 'get'
  })
}
// 企业员工列表
export function getstaffList(params) {
  return request({
    url: `/workWechat/user/list`,
    method: 'get',
    params
  })
}
// 客服创建
export function customerservicecreat(data) {
  return request({
    url: `/workWechat/kf/store`,
    method: 'post',
    data
  })
}
// 客服消息创建2
export function customerservicecreatv2(data) {
  return request({
    url: '/workWechat/kf/storeV2',
    method: 'post',
    data
  })
}
// 客服列表
export function customerservicelist(params) {
  return request({
    url: `/workWechat/kf/index`,
    method: 'get',
    params
  })
}
// 客服删除
export function customerservicedelte(data) {
  return request({
    url: `/workWechat/kf/destroy`,
    method: 'post',
    data
  })
}
// 客服更新
export function updayaservicedelte(data) {
  return request({
    url: `/workWechat/kf/update`,
    method: 'post',
    data
  })
}
// 新增条数
export function updayaservicedelter(data) {
  return request({
    url: `/workWechat/kf/addLink`,
    method: 'post',
    data
  })
}
// 数据
export function alldatalist(params) {
  return request({
    url: `/workWechat/kf/countData`,
    method: 'get',
    params
  })
}
// 预添加微信客服
export function beforehandstore(data) {
  return request({
    url: `/workWechat/kf/beforehandStore`,
    method: 'post',
    data
  })
}
// 换一批客服人员
export function changebatch(params) {
  return request({
    url: `/workWechat/kf/changeBatch`,
    method: 'get',
    params
  })
}

